import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../../config/api';
import { addCampaigns } from '../../../features/createBudget/createBudgetSlice';

export const useCampaigns = ({ 
  dataPaginationCampaignTab, 
  pageSize, 
  debouncedSearchTerm, 
  statusCampaign,
  accountIds,
  setSearchResults 
}) => {
  const dispatch = useDispatch();
  
  const { 
    choosenSources,
    choosenAccounts, 
    setCampaignsTab,
    isProcessSyncDataSource
  } = useSelector(state => state.createBudget);
  
  const [isLoading, setIsLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const fetchCampaignData = async () => {
      const idAccount = choosenAccounts.length ? choosenAccounts[0].id : '';
      const idFetchingCampaigns =
        setCampaignsTab === 'accounts' || (!idAccount && !accountIds.length);

      if (idFetchingCampaigns) return;

      setIsLoading(true);

      try {
        const params = {
          page: dataPaginationCampaignTab.currentPage,
          size: pageSize.value,
          ...(debouncedSearchTerm !== '' && { search: debouncedSearchTerm }),
          ...(statusCampaign !== '' && { status_filter: statusCampaign }),
          ...(accountIds.length &&
            !idAccount && { accounts_filter: accountIds.join(',') }),
        };

        const res = await api.GET_CAMPAIGNS(idAccount, params);
        const { results, count } = res;
        setTotalItems(count);

        setSearchResults(results);
        dispatch(addCampaigns(results));
      } catch (error) {
        setSearchResults([]);
        dispatch(addCampaigns([]));
      } finally {
        setIsLoading(false);
      }
    };

    fetchCampaignData();
  }, [
    choosenSources,
    choosenAccounts,
    statusCampaign,
    dataPaginationCampaignTab.currentPage,
    dataPaginationCampaignTab.totalItems,
    setCampaignsTab,
    debouncedSearchTerm,
    accountIds,
    pageSize.value,
    setSearchResults,
    isProcessSyncDataSource,
    dispatch
  ]);

  return {
    isLoading,
    totalItems,
  };
};